// Constants / utils
import { NEWS_AI_GENERIC_ERROR_MESSAGE } from 'NewsApp/constants';
import { YChartsSentryUtils } from 'NewAngular/services/sentry/sentry-utils';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class NewsAIService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getQueryChoices(securityId) {
        const url = this.urlsService.getUrl(this.urlsService.NEWS.AI_CHAT_QUERY_CHOICES, { securityId });
        return this.ajaxService.getDataObserveBody(url);
    }
    streamAnswer(query, tokenHandler, completeHandler, errorHandler, securityId) {
        const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:3003' : process.env.AI_PROXY_BASE_URL;
        const stream = new EventSource(`${baseUrl}/news?query=${encodeURIComponent(query)}&securityId=${securityId || ''}`, {
            withCredentials: true,
        });
        stream.onmessage = (event) => {
            // Newline characters are URL-encoded as %0A so that they don't interfere with the server-sent events protocol.
            // We decode them here to preserve the formatting of the original response.
            tokenHandler(event.data.replace(/%0A/g, '\n'));
        };
        stream.addEventListener('sources', (event) => {
            completeHandler(JSON.parse(event.data));
            stream.close();
        });
        stream.onerror = (e) => {
            errorHandler(NEWS_AI_GENERIC_ERROR_MESSAGE);
            YChartsSentryUtils.captureException(e);
            stream.close();
        };
    }
}
NewsAIService.ɵfac = function NewsAIService_Factory(t) { return new (t || NewsAIService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
NewsAIService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NewsAIService, factory: NewsAIService.ɵfac, providedIn: 'root' });
